module.exports = __webpack_public_path__ + "18850d25a0a36c933c5c35c1d46b4c6a.svg";